import React from 'react';
import PropTypes from 'prop-types';
import styles from './sliderBtn.module.scss';

const SliderBtn = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    className={isActive ? styles.cwSliderBtnActive : styles.cwSliderBtn}>
    <path
      d="M5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z"
      fillOpacity="0.8"
    />
  </svg>
);

SliderBtn.propTypes = {
  isActive: PropTypes.bool,
};

export default SliderBtn;
